// Admin Imports
import { MdLock } from "react-icons/md";
import Announcement from "views/admin/announcements";
import FLMessage from "views/admin/flMessage";
// import AddForm from "views/admin/flMessage/components/AddForm";

import { ReactComponent as AnnouncementIcon } from "./assets/svg/announcement.svg";
import { ReactComponent as AppConfigIcon } from "./assets/svg/app-config.svg";
import { ReactComponent as BulbIcon } from "./assets/svg/bulb.svg";
import { ReactComponent as EventsIcon } from "./assets/svg/events.svg";
import { ReactComponent as FileIcon } from "./assets/svg/file-edit.svg";
import { ReactComponent as MessageIcon } from "./assets/svg/message-text.svg";
import { ReactComponent as VideoLbIcon } from "./assets/svg/video-library.svg";
import { ReactComponent as AdminIcon } from "./assets/svg/user-rounded .svg";
import { ReactComponent as CronJobsIcon } from "./assets/svg/cron-jobs.svg";
import { ReactComponent as StatisticsIcon } from "./assets/svg/statistics.svg";

import AddAnnouncement from "components/add-announcement/add-announcement";
import AddFlInitiative from "components/add-fl-initiative/add-fl-initiative";
import AddForms from "components/add-forms/add-forms";
import AddLiveEvents from "components/add-live-events/add-live-events";
import AddVideoCategory from "components/add-video-category/add-video-category";
import AddVideos from "components/add-videos/add-videos";
import FlInitiatives from "views/admin/fl-initiatives";
import Forms from "views/admin/forms";
import LiveEvents from "views/admin/live-event";
import VideoGallery from "views/admin/video-gallery";
import { ReactComponent as AnnouncementFilledIcon } from "./assets/svg/announcement-filled.svg";
import { ReactComponent as AppConfigFilledIcon } from "./assets/svg/app-config-filled.svg";
import { ReactComponent as BulbFilledIcon } from "./assets/svg/bulb-filled.svg";
import { ReactComponent as EventsFilledIcon } from "./assets/svg/events--filled.svg";
import { ReactComponent as FileFilledIcon } from "./assets/svg/file-edit--filled.svg";
import { ReactComponent as MessageFilledIcon } from "./assets/svg/message-text-filled.svg";
import { ReactComponent as VideoLbFilledIcon } from "./assets/svg/video-library--filled.svg";
import { ReactComponent as AdminFilledIcon } from "./assets/svg/user-rounded filled.svg";
import { ReactComponent as CronJobsFilledIcon } from "./assets/svg/cron-jobs-filled.svg";
import { ReactComponent as StatisticsFilledIcon } from "./assets/svg/statistics--filled.svg";

import AddFlMessage from "components/add-fl-message/add-fl-message";
import AppConfig from "views/admin/app-config";
import SpecialMessage from "views/admin/special-message";
import VideoCategory from "views/admin/video-category";
import SignIn from "../src/views/auth/signIn/index";
import Admins from "views/admin/admins";
import AddAdmin from "components/add-admin/add-admin";
import ResetPassword from "views/auth/resetPassword";
import UpdateAdmin from "components/update-admin/update-admin";
import CronJobs from "views/admin/cron-jobs";
import Statistics from "views/admin/statistics";

const isSuperAdmin = localStorage.getItem("role");

const routes = [
  // {
  //   name: "Dashboard",
  //   layout: "/admin",
  //   path: "default",
  //   icon: <DashboardIcon className="h-6 w-6" />,
  //   filledIcon: <DashboardFilledIcon className="h-6 w-6" />,
  //   component: <Hello />,
  //   sideBarVisible: true,
  // },

  {
    name: "ResetPassword",
    layout: "/auth",
    path: "resetpassword",
    icon: <AnnouncementIcon className="h-6 w-6" />,
    filledIcon: <AnnouncementFilledIcon className="h-6 w-6" />,
    component: <ResetPassword />,
    sideBarVisible: false,
    secondary: false,
  },
  {
    name: "SignIn",
    layout: "/auth",
    path: "signin",
    icon: <AnnouncementIcon className="h-6 w-6" />,
    filledIcon: <AnnouncementFilledIcon className="h-6 w-6" />,
    component: <SignIn />,
    sideBarVisible: false,
    secondary: false,
  },
  {
    name: "Announcements",
    layout: "/admin",
    path: "announcement",
    icon: <AnnouncementIcon className="h-6 w-6" />,
    filledIcon: <AnnouncementFilledIcon className="h-6 w-6" />,
    component: <Announcement />,
    secondary: true,
    sideBarVisible: true,
  },
  {
    name: "Financial Literacy Message",
    layout: "/admin",
    path: "fl-lt-message",
    icon: <MessageIcon className="h-6 w-6" />,
    filledIcon: <MessageFilledIcon className="h-6 w-6" />,
    component: <FLMessage />,
    secondary: true,
    sideBarVisible: true,
  },
  {
    name: "Add FL Message",
    layout: "/admin",
    path: "fl-lt-message/add",
    icon: <MdLock className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    sideBarVisible: false,
    component: <AddFlMessage />,
    secondary: false,
  },
  {
    name: "Edit FL Message",
    layout: "/admin",
    path: "fl-lt-message/edit",
    icon: <MdLock className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    sideBarVisible: false,
    component: <AddFlMessage />,
    secondary: false,
  },
  {
    name: "Upcoming Live Events",
    layout: "/admin",
    path: "live-events",
    icon: <EventsIcon className="h-6 w-6" />,
    filledIcon: <EventsFilledIcon className="h-6 w-6" />,
    component: <LiveEvents />,
    secondary: true,
    sideBarVisible: true,
  },

  {
    name: "Add Live Events",
    layout: "/admin",
    path: "live-events/add",
    icon: <MdLock className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    sideBarVisible: false,
    component: <AddLiveEvents />,
    secondary: false,
  },
  {
    name: "Edit Live Events",
    layout: "/admin",
    path: "live-events/edit",
    icon: <MdLock className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    sideBarVisible: false,
    component: <AddLiveEvents />,
    secondary: false,
  },
  {
    name: "Request For Programmes",
    layout: "/admin",
    path: "forms",
    icon: <FileIcon className="h-6 w-6" />,
    filledIcon: <FileFilledIcon className="h-6 w-6" />,
    component: <Forms />,
    secondary: true,
    sideBarVisible: true,
  },

  {
    name: "Add Forms",
    layout: "/admin",
    path: "forms/add",
    icon: <FileIcon className="h-6 w-6" />,
    filledIcon: <FileFilledIcon className="h-6 w-6" />,
    component: <AddForms />,
    secondary: false,
    sideBarVisible: false,
  },

  {
    name: "Edit Forms",
    layout: "/admin",
    path: "forms/edit",
    icon: <FileIcon className="h-6 w-6" />,
    filledIcon: <FileFilledIcon className="h-6 w-6" />,
    component: <AddForms />,
    secondary: false,
    sideBarVisible: false,
  },
  {
    name: "FL Initiatives",
    layout: "/admin",
    path: "fl-initiatives",
    icon: <BulbIcon className="h-6 w-6" />,
    filledIcon: <BulbFilledIcon className="h-6 w-6" />,
    component: <FlInitiatives />,
    secondary: true,
    sideBarVisible: true,
  },
  {
    name: "Video Gallery",
    layout: "/admin",
    path: "video-gallery",
    icon: <VideoLbIcon className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    component: <VideoGallery />,
    secondary: true,
    sideBarVisible: true,
  },
  {
    name: "Video Category",
    layout: "/admin",
    path: "video-category",
    icon: <VideoLbIcon className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    component: <VideoCategory />,
    secondary: true,
    sideBarVisible: true,
  },
  {
    name: "Add Video to Gallery",
    layout: "/admin",
    path: "video-gallery/add",
    icon: <MdLock className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    sideBarVisible: false,
    component: <AddVideos />,
    secondary: false,
  },

  {
    name: "Edit Video",
    layout: "/admin",
    path: "video-gallery/edit",
    icon: <MdLock className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    sideBarVisible: false,
    component: <AddVideos />,
    secondary: false,
  },
  {
    name: "Add Video Category",
    layout: "/admin",
    path: "video-category/add",
    icon: <MdLock className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    sideBarVisible: false,
    component: <AddVideoCategory />,
    secondary: false,
  },
  {
    name: "Edit Video Category",
    layout: "/admin",
    path: "video-category/edit",
    icon: <MdLock className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    sideBarVisible: false,
    component: <AddVideoCategory />,
    secondary: false,
  },
  {
    name: "Add Announcement",
    layout: "/admin",
    path: "announcement/add",
    icon: <MdLock className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    sideBarVisible: false,
    component: <AddAnnouncement />,
    secondary: false,
  },
  {
    name: "Edit Announcement",
    layout: "/admin",
    path: "announcement/edit",
    icon: <MdLock className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    sideBarVisible: false,
    component: <AddAnnouncement />,
    secondary: false,
  },
  {
    name: "Add FL Initiative",
    layout: "/admin",
    path: "fl-initiatives/add",
    icon: <MdLock className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    sideBarVisible: false,
    component: <AddFlInitiative />,
    secondary: false,
  },
  {
    name: "Edit FL Initiative",
    layout: "/admin",
    path: "fl-initiatives/edit",
    icon: <MdLock className="h-6 w-6" />,
    filledIcon: <VideoLbFilledIcon className="h-6 w-6" />,
    sideBarVisible: false,
    component: <AddFlInitiative />,
    secondary: false,
  },
  {
    name: "App Config",
    layout: "/admin",
    path: "app-config",
    icon: <AppConfigIcon className="h-6 w-6" />,
    filledIcon: <AppConfigFilledIcon className="h-6 w-6" />,
    sideBarVisible: true,
    component: <AppConfig />,
    secondary: true,
  },
  {
    name: "Special Message",
    layout: "/admin",
    path: "special-message",
    icon: <MessageIcon className="h-6 w-6" />,
    filledIcon: <MessageFilledIcon className="h-6 w-6" />,
    component: <SpecialMessage />,
    secondary: true,
    sideBarVisible: true,
  },
  {
    name: "Cron Jobs",
    layout: "/admin",
    path: "cron-jobs",
    icon: <CronJobsIcon className="h-6 w-6" />,
    filledIcon: <CronJobsFilledIcon className="h-6 w-6" />,
    component: <CronJobs />,
    secondary: true,
    sideBarVisible: true,
  },
  {
    name: "Statistics",
    layout: "/admin",
    path: "Statistics",
    icon: <StatisticsIcon className="h-6 w-6" />,
    filledIcon: <StatisticsFilledIcon className="h-6 w-6" />,
    component: <Statistics />,
    secondary: true,
    sideBarVisible: true,
  },
];

if (isSuperAdmin === "superAdmin") {
  routes.push(
    {
      name: "Admins",
      layout: "/admin",
      path: "all-admins",
      icon: <AdminIcon className="h-6 w-6" />,
      filledIcon: <AdminFilledIcon className="h-6 w-6" />,
      component: <Admins />,
      secondary: true,
      sideBarVisible: true,
    },
    {
      name: "Add Admins",
      layout: "/admin",
      path: "all-admins/add",
      icon: <MessageIcon className="h-6 w-6" />,
      filledIcon: <MessageFilledIcon className="h-6 w-6" />,
      component: <AddAdmin />,
      secondary: true,
      sideBarVisible: false,
    },
    {
      name: "Edit Admins",
      layout: "/admin",
      path: "update-user",
      icon: <MessageIcon className="h-6 w-6" />,
      filledIcon: <MessageFilledIcon className="h-6 w-6" />,
      component: <UpdateAdmin />,
      secondary: true,
      sideBarVisible: false,
    }
  );
}
export default routes;
